module.exports = __webpack_public_path__ + "img/图1-9  手写数字“1”及其对应二维矩阵.f370e35e.png";